<div class="share-member-list">
  <sync-dialog
    [config]="{
      title: 'Folder settings',
      subTitle: name,
      isClosable: true,
      closeIcon:'arrow-left',
      onCloseIcon: onBack,
      cancelButton: 'Back',
      onCancelClick: onBack,
    }"
    [open]="showDialog"
    [isFullScreen]="isSmallScreen"
  >
  <div class="settings-container">
      <div class="leave-section">
          <sync-section-header class="leave-section-header" [header]="'Remove sharing'"
          [description]="'Stop sharing the files in this folder'"
              [level]="'subtitle'" [showActions]="true"
              [showButton]="true"
              [buttonConfig]="{label: 'Unshare', type: 'outlined', color: 'critical', size:'small', leadAdornment:false, onClick: onUnshare.bind(this)}">
          </sync-section-header>
      </div>
  </div>
  </sync-dialog>
</div>
